import { createSHA256 } from 'hash-wasm';

export function formatFileSize(bytes?: number | null) {
  if (bytes === undefined || bytes === null || bytes < 0) {
    return '-';
  }
  if (bytes === 0) {
    return '0 B';
  }
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const size = bytes / Math.pow(1024, i);
  return `${size.toFixed(i === 0 ? 0 : 2)} ${units[i]}`;
}

export async function getFileHash(file: File, chunkSize = 5 * 1024 * 1024) {
  const sha256 = await createSHA256();
  sha256.init();

  let offset = 0;
  while (offset < file.size) {
    const chunk = file.slice(offset, offset + chunkSize);
    const buffer = await chunk.arrayBuffer();
    sha256.update(new Uint8Array(buffer));
    offset += chunkSize;
  }

  return sha256.digest('hex');
}
